import request from '@/utils/request'

// 确认接单
export function additionalItemOrderConfirm(id, data) {
  return request({
    url: `/additional_item_orders/${id}/confirm`,
    method: 'post',
    data
  })
}

// 确认发货
export function additionalItemOrderDeliver(id, data) {
  return request({
    url: `/additional_item_orders/${id}/deliver`,
    method: 'post',
    data
  })
}

// 查询发货信息
export function findAdditionalItemOrderDeliver(id, params) {
  return request({
    url: `/additional_item_orders/${id}/deliver_info`,
    method: 'get',
    params: params
  })
}

// 查询已送达信息
export function findAdditionalItemOrderDelivered(id, params) {
  return request({
    url: `/additional_item_orders/${id}/delivered_info`,
    method: 'get',
    params: params
  })
}

export function updateAdditionalItemOrderDeliver(id, data) {
  return request({
    url: `/additional_item_orders/${id}/update_deliver`,
    method: 'post',
    data
  })
}

// 送达
export function additionalItemOrderDelivered(id, data) {
  return request({
    url: `/additional_item_orders/${id}/delivered`,
    method: 'post',
    data
  })
}

// 修改送达信息
export function updateAdditionalItemOrderDelivered(id, data) {
  return request({
    url: `/additional_item_orders/${id}/update_delivered`,
    method: 'post',
    data
  })
}

// 订单取消
export function additionalItemOrderCancel(id, data) {
  return request({
    url: `/additional_item_orders/${id}/cancel`,
    method: 'post',
    data
  })
}
